import { render, staticRenderFns } from "./wettmpInfoModule.vue?vue&type=template&id=152aa2cc&scoped=true"
import script from "./wettmpInfoModule.vue?vue&type=script&lang=js"
export * from "./wettmpInfoModule.vue?vue&type=script&lang=js"
import style0 from "./wettmpInfoModule.vue?vue&type=style&index=0&id=152aa2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152aa2cc",
  null
  
)

export default component.exports